<template>

    <div class="info">
        <div v-if="translationIsOwn"
             class="own">
        </div>
        <div v-else 
             class="group">            
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Translation } from '@/models/TranslationVariants';

    import { segmentTextLogicService } from '@/services/translationSegment/segmentTextLogicService';

    export default defineComponent({
        props: {
            translationVariant: {
                type: Object as PropType<Translation>,
                mandatory: true
            }
        },
        data() {
            return {
                segmentTextLogicService: segmentTextLogicService.getInstance(),
            }
        },
        computed: {
            translationIsOwn(): boolean {
                return this.segmentTextLogicService.ownershipIsOwn(this.translationVariant);
            },
        },
    })

</script>

<style lang="scss" scoped>
    .info {
        display: flex;
        justify-content: center;
    }
    .own {
        background-image: url(/src/images/personal.svg);
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
    }

    .group {
        background-image: url(/src/images/group.svg);
        width: 30px;
        height: 24px;
        background-repeat: no-repeat;
    }



</style>